import React, { ChangeEvent, useState } from 'react';
import ReferralMethod from './ReferralMethod';
import { client, consoleLogInDev, formatPhoneAsYouType, track, formatE164USPhoneNumber, isValidPhone } from 'shared';
import { Text, TextButton } from 'library';
import { Grid } from '@material-ui/core';
import { trackReferralEngagement } from 'api/UserApi';
import { useLocation } from 'react-router-dom';
import { useUserContext } from 'UserContext';

const InviteProviderToTandem = ({ referralContext }: { referralContext: string }) => {
    const [buttonText, setButtonText] = useState('Send');
    const [phone, setPhone] = useState('');
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const { user } = useUserContext();
    const location = useLocation();

    const changePhone = (e: ChangeEvent<{ value: string }>) => {
        setButtonText('Send');
        setPhone(formatPhoneAsYouType(e.target.value));
    };

    const trackAndSendText = () => {
        setLoading(true);
        if (user) {
            trackReferralEngagement(user.id, location.pathname, `${referralContext}: Share via Text`)
                .then((response) => response.id)
                .catch(consoleLogInDev)
                .then(sendText)
                .catch(consoleLogInDev)
                .finally(() => {
                    setLoading(false);
                    setButtonText('Sent!');
                });
        }
        track('Referrals: Provider Referral Sent', { phone });
    };

    function sendText(reid?: number) {
        return client(`tracking/api/referral/send/?phone_number=True`, {
            body: {
                phoneNumber: formatE164USPhoneNumber(phone),
                referProvider: true,
                reid: !!reid ? reid : null,
            },
        });
    }

    return (
        <Grid style={{ alignSelf: 'flex-start', paddingTop: 40 }}>
            <TextButton
                buttonStyle={{ maxWidth: 280 }}
                onClick={() => {
                    track('Referrals: Invite a care provider to join Tandem pressed ');
                    setShow(!show);
                }}
            >
                Invite a care provider to join Tandem
            </TextButton>
            {show ? (
                <ReferralMethod
                    title={
                        <Text variant="body1" bold textStyle={{ lineHeight: 3 }}>
                            Invite via text message
                        </Text>
                    }
                    buttonText={buttonText}
                    action={trackAndSendText}
                    buttonProps={{ disabled: !isValidPhone(phone) || loading }}
                    inputProps={{
                        placeholder: '(XXX) XXX-XXXX',
                        value: phone,
                        onChange: changePhone,
                        error: !isValidPhone(phone),
                        helperText: phone && !isValidPhone(phone) ? 'Please enter a valid phone number.' : '',
                    }}
                />
            ) : null}
        </Grid>
    );
};

export default InviteProviderToTandem;
